<template>
  <div class="company">
    <div class="banner">
      <div class="company-div">
        <div class="display-4">Agram Infotech</div>
        <div class="display-1 mt-2">You Dream, We Make It Happen</div>
      </div>
    </div>
    <v-container class="mt-5">
      <v-row>
        <v-col cols="12" sm="6" v-for="(c, i) in company" :key="i">
          <div class="dm pa-4" @click.prevent="() => $router.push(c.to)">
            <img :src="c.img" :alt="c.name" >
            <div class="dm-title my-3">{{ c.name }}</div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div> 
</template>

<script>
export default {
  metaInfo: () => ({
    title: 'Company | Agram Infotech',
    meta: [
      { name: 'description', content: 'Agram Infotech Company' },
      { property: 'og:title', content: 'Agram Infotech' },
      { property: 'og:site_name', content: 'Agram Infotech'},
      { property: 'og:description', content: 'This is home content' },
      { property: 'og:type', content: 'company' },
      { property: 'og:url', content: 'https://agraminfotech.com/company' },   
    ]
  }),
  data: () => ({
    company: [
      { name: 'About Us', img: require('@/assets/icons/about.png'), to: '/company/about-us' },
      // { name: 'Success Stories', img: require('@/assets/icons/stories.png') },
      { name: 'Portfolio' , img: require('@/assets/icons/portfolio.png'), to: '/company/portfolio' },
      { name: 'Career', img: require('@/assets/icons/career.png'), to: '/company/career' },
      { name: 'Gallery', img: require('@/assets/icons/gallery.png'), to: '/company/gallery' }
    ]
  })
}
</script>

<style scoped>
.banner { background-image: url('https://thesupermexx.com/img/about-banner.jpg'); }
</style>